import React, {Component} from "react";
import Navbar from "./layouts/Navbar";
import HeaderRight from "./layouts/HeaderRight";
import {Link} from "react-router-dom";
//import AutoNotification from "./layouts/AutoNotification";
import { withTranslation } from 'react-i18next';
import {post} from '../networking/Api'
import Constent from '../networking/Constent';
import {Alert} from "./../alertServices";
import UserSlider from './HomeUserSlider';
import CheckinPopup from "./timeregistration/CheckinPopup";
import {
    PullToRefresh,
    PullDownContent,
    ReleaseContent,
    RefreshContent
  } from "react-js-pull-to-refresh";

const dummyImage =  process.env.PUBLIC_URL + '/assets/img/placeholder.png';

var employees = {
  menu: [],
  more:[],
  summaryDetail: []

};
var communication = {
  menu: []
}
//var location='';
class Home extends Component {

    constructor(props) {
        super(props);
        var defaultPage = 'employee';//menu
        this.state = {
            value: defaultPage,
            department_id: '',
            temp_department_id:'',
            userType : '',
            user_id : '',
            menu_list : [],
            department_list: [],
            //user_list: [],
            user_list_carousel: [],
            is_user_list_carousel:false,
            profile_image : '',
            user_name:'',
            company_name:'',
            department_name:'',

            shift_time:'00:00',
            shift_count:'0',
            time_paid_time:'00:00',
            time_break_time:'00:00',
            absence_amount:'0',
            absence_count:'0',
            workschedule_hour:'00:00',
            project_hour:'00:00',
            project_count:'0',
            terminal_count:'0',
            start_date:'',
            end_date:'',

            integration_setting_option:'general',
            timeregistration_start_of_payment: '',
            timeregistration_date_filter:'monthly',

            timeregistration_check_in_out_note:false,
            timeregistration_emp_edit:false,
            timeregistration_checkin_with_time:false,
            timeregistration_display_page: false,
            timeregistration_display_page_guest: false,
            timeregistration_guest_edit: false,
            timeregistration_break_after:'',
            timeregistration_break_time:'',
            timeregistration_break_payment:'',
            timeregistration_meeting_minute:'', // record_rule
            timeregistration_leaving_minute:'', // record_rule
            timeregistration_auto_logout_time:'', // record_rule

            flex_is_user_menu: false,
            flex_see_schema: false,
            flex_addedit_schema: false,
            flex_addedit_record:false,
            flex_checkin_with_flex:false,

            shift_sc_display_shift_with_user_module:false,
            shift_sc_checkinout_with_shift:false,
            shift_sc_share_shift_schema_publiclly:false,
           
            shift_sc_display_shift_with_guest_module:false,
            integration_tr_text_guest_can_edit_record:false,

            shift_sc_show_hide_empty_rows_on_week_and_day_overvie:false,
            shift_sc__show_hide_empty_rows_on_webapp:false,
            shift_sc_employee_pays_breaks:false,

            shift_from_time: '',
            shift_to_time : '',

            shift_assignment_list : [],
            shift_common_shift_list: [],
            shift_sc_hidden_days:[],

            project_display_page : false,
            project_choose_project_check_in: false,

            absence_display_page: false,
            emp_edit : 1,
            search: true,

            last_meeting_datetime:'',
        }

        // if(navigator.geolocation) {
        //     navigator.geolocation.getCurrentPosition(this.showPosition)
        // } else {
        //   console.log("Geo Location not supported by browser");
        // }
    this.handleRefresh = this.handleRefresh.bind(this);

    }

    handleRefresh() {
        return new Promise(resolve => {
            this.getMenuSummery(resolve);
            let userType = (localStorage.getItem('user_data') === null) ? 'user' : JSON.parse(localStorage.getItem('user_data')).user_type;

            if(userType == "department") {
                this.fetchMenuList();
            }
        });
      }

    //function that retrieves the position
    // showPosition(position) {
    //   location = {
    //     longitude: position.coords.longitude,
    //     latitude: position.coords.latitude
    //   }
    // }
    
    componentDidMount(){
        const { t } = this.props;

        let userid = localStorage.getItem('userid');
        if(userid  === null){
            this.props.history.push('/signin');
            return false;
        }
        let is_user_login = localStorage.getItem('is_user_login');
        if(is_user_login !== 'true'){
            this.props.history.push('/pin-verification');
        }

        var checkin_with_time = (localStorage.getItem('timestamp_option') === null) ? '' : JSON.parse(localStorage.getItem('timestamp_option')).checkin_with_time;
        this.setState({
          timeregistration_checkin_with_time:(checkin_with_time === 1) ? true : false,
        });

        this.getMenuSummery();
        document.getElementById("body").classList.remove("bg-theme");
        
        let menu_permission= localStorage.getItem('menu_permission');
        this.getDashboardMenuItems();
         
        
          this.setState({
            user_id:userid,
            menu_list: JSON.parse(menu_permission),
            profile_image: (localStorage.getItem('user_data') === null) ? dummyImage : JSON.parse(localStorage.getItem('user_data')).profile_image ,
            user_name : (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).name,
            company_name : (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).company_name,
            department_name: (localStorage.getItem('department_name') === null) ? '' : localStorage.getItem('department_name')
          })
        
        
    }

    fetchMenuList() {
        var depId = localStorage.getItem('department_id');
        var formData=new FormData();
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("department_id",depId)
        post(Constent.CHANGEDEPARTMENT,formData).then(response=>{
          if(response.status===1)
          {
            this.setState({ department_id: depId });
            localStorage.setItem('department_id',this.state.department_id);
            localStorage.setItem('department_name',response.department_name);
            localStorage.setItem('menu_permission', JSON.stringify(response.menu_permission));
            localStorage.setItem('timestamp_option',JSON.stringify(response.timestamp_option));

            this.getDashboardMenuItems();
          } else{
            Alert.error({title: response.message});
          }
        })
    }

    getDashboardMenuItems() {
        const { t } = this.props;

        employees.menu=[];
        communication.menu=[];
        employees.menu_ary = [];
        let menu_permission= localStorage.getItem('menu_permission');
        let departmentId = localStorage.getItem('department_id');
        let userType = (localStorage.getItem('user_data') === null) ? 'user' : JSON.parse(localStorage.getItem('user_data')).user_type;
        let department_list= localStorage.getItem('department_list');
        this.setState({ 
          menu_list: JSON.parse(menu_permission),
          department_list:JSON.parse(department_list),
          department_id : departmentId,
          temp_department_id : departmentId,
        });
        
        communication.menu.push({ 
          "integration_id" : 'email_address',
          "integration_name"  : t('lang.email_address'),
          "integration_icon"  : <i className="fa fa-envelope"></i>,
        },{ 
          "integration_id" : 'teliphone_number',
          "integration_name"  : t('lang.contact_number'),
          "integration_icon"  : <i className="fa fa-phone"></i>,
        },{ 
          "integration_id" : 'birthday_list',
          "integration_name"  : t('lang.birthdays'),
          "integration_icon"  : <i className="fa fa-birthday-cake"></i>,
        },{ 
          "integration_id" : 'email',
          "integration_name"  : t('lang.email'),
          "integration_icon"  : <i className="fa fa-envelope-o"></i>, 
        },{ 
          "integration_id"    : 'chat',
          "integration_name"  : t('lang.chat'),
          "integration_icon"  : <i className="fa fa-commenting-o"></i>,
        });
        
        this.setState({userType:userType})
        if(userType=== "department" ){
            employees.more=[]
            employees.more.push({ 
              "integration_id" : 21,
              "integration_name"  : t('lang.department'),
            });
        }
         
        var menulist=JSON.parse(menu_permission);

        if( userType === "department" ){
          employees.menu.push({ 
            "integration_id" : 'attend_device',
            "integration_name"  : t('lang.menu_name_attend_device'),
            "integration_icon" : 'stamp.png',
            "page_url" : 'device-timestamp'
          });   
        }
        
       try { 
          menulist.map(item => {
          if( (item.integration_id===10) && (userType !== "department") ){ // device
            employees.menu_ary.push(item.integration_id);
            employees.menu.push({ 
              "integration_id" : 'guest_attend_device',
              "integration_name"  : t('lang.menu_name_attend_device'),
              "integration_icon" : 'stamp.png',
              "page_url" : 'device-timestamp',
              "total_notifications": item.notification_total
            });
          }
          if(item.integration_id===2){ // timeregistration
              var currurl =  (localStorage.getItem('user_type') !== 'user') ? 'timeregistration-userlist' : 'timeregistration-user/'+localStorage.getItem('userid');
              employees.menu_ary.push(item.integration_id);
              employees.menu.push({ 
                  "integration_id" : item.integration_id,
                  "integration_name"  : t('lang.menu_name_time_registration'),
                  "integration_icon"  : 'time_registration.png',
                  "page_url" : currurl,
                  "total_notifications": item.notification_total
              });
          }
          if(item.integration_id===1){ // Shift
             currurl =  (localStorage.getItem('user_type') !== 'user') ? 'shift-userlist' : 'shift-user/'+localStorage.getItem('userid');
            employees.menu.push({ 
              "integration_id" : item.integration_id,
              "integration_name"  : t('lang.menu_name_shift_schedule'),
              "integration_icon"  : 'shift.png',
              "page_url" : currurl,
              "total_notifications": item.notification_total
            });
            employees.menu_ary.push(item.integration_id);
          }
          
          if(item.integration_id===11){ // CREW
            employees.menu_ary.push(item.integration_id);
            employees.menu.push({ 
                "integration_id" : item.integration_id,
                "integration_name"  : t('lang.menu_name_crew'),
                "integration_icon"  : 'shift.png',
                "page_url" : '#',
                "total_notifications": item.notification_total
            });
          }
          if(item.integration_id===3){ // absence
              currurl =  (localStorage.getItem('user_type') !== 'user') ? 'absence-list' : 'user-absence-list';
            employees.menu_ary.push(item.integration_id);
            employees.menu.push({ 
              "integration_id" : item.integration_id,
              "integration_name"  : t('lang.menu_name_absence'),
              "integration_icon"  : 'absence.png',
              "page_url" : currurl,
              "total_notifications": item.notification_total
          });
          }
          if(item.integration_id===5){ // Flex Schema
               currurl =  (localStorage.getItem('user_type') !== 'user') ? 'flex-userlist' : 'flex-detail/'+localStorage.getItem('userid'); 
              employees.menu_ary.push(item.integration_id);
              employees.menu.push({ 
                "integration_id" : item.integration_id,
                "integration_name"  : t('lang.menu_name_flex_schema'),
                "integration_icon"  : 'flex.png',
                "page_url" : currurl,
                "total_notifications": item.notification_total
            });
          }
          
          if( (item.integration_id===6) && (userType !== "guest") ){ // Project
            employees.menu_ary.push(item.integration_id);
            employees.menu.push({ 
              "integration_id" : item.integration_id,
              "integration_name"  : t('lang.menu_name_project'),
              "integration_icon"  : 'project.png',
              "page_url" : 'project-list',
              "total_notifications": item.notification_total
            });
          }

          return employees.menu
      });
    }catch(e){
        console.log('error in home.js try catch blog'+e);
        this.props.history.push('/signin');
    }

        if(employees.menu_ary.includes(2)){ // timeregistration
            this.setState({'value' : 2});
        }else if(employees.menu_ary.includes(10)  && (userType  !== "department")){ // Guest Attend Device
            this.setState({'value' : 'guest_attend_device'});
        }else if(employees.menu_ary.includes(10)  && (userType=== "department")){ // Guest Attend Device
            this.setState({'value' : 'attend_device'});
        }else if(employees.menu_ary.includes(1)){ // Shift
            this.setState({'value' : 1});
        }else if(employees.menu_ary.includes(11)){ // Crew
            this.setState({'value' : 11});
        }else if(employees.menu_ary.includes(5)){ // Flex Schema
            this.setState({'value' : 5});
        }else if(employees.menu_ary.includes(6)){ // Project
            this.setState({'value' : 6});
        }else{
            this.setState({'value' : 'employee'});
        }
      
    }



    getUserList(){
        var user_id= localStorage.getItem('userid');
        var formData = new FormData();
        formData.append("user_id",user_id);
        post(Constent.CONTACT,formData).then(response=>{
          if(response.status){
            this.setState({user_list_carousel:response.user_list, is_user_list_carousel : true});
          }else{
            Alert.error({title: response.message});
          }
        })
    }

    handleChangeDepartment = (depId) => {
        var formData=new FormData();
        formData.append("user_id", localStorage.getItem('userid'));
        formData.append("department_id",depId)
        post(Constent.CHANGEDEPARTMENT,formData).then(response=>{
          if(response.status===1){
            this.setState({ department_id: depId });
            localStorage.setItem('department_id',this.state.department_id);
            localStorage.setItem('department_name',response.department_name);
            localStorage.setItem('menu_permission', JSON.stringify(response.menu_permission));
            localStorage.setItem('timestamp_option',JSON.stringify(response.timestamp_option));
            Alert.success({title: response.message});
            window['modalClose']();
            document.getElementById('logout-btn').click();
          }else{
            Alert.error({title: response.message});
          }
        })
    };

    getMenuSummery(resolve){
        var userType = (localStorage.getItem('user_data') === null) ? '' : JSON.parse(localStorage.getItem('user_data')).user_type_id;
        var start_date = (localStorage.getItem('timestamp_option') === null) ? '' : JSON.parse(localStorage.getItem('timestamp_option')).date_range.start_date;
        var end_date = (localStorage.getItem('timestamp_option') === null) ? '' : JSON.parse(localStorage.getItem('timestamp_option')).date_range.end_date;
       
        var formData = new FormData();
        formData.append("user_id",localStorage.getItem('userid'));
        formData.append("department_id",localStorage.getItem('department_id'));
        formData.append("user_type",userType);
        formData.append("start_date",start_date);
        formData.append("end_date",end_date);
        post(Constent.DASHBOARDMENUSUMMARY,formData).then(response=>{
          if(response.status){
            this.setState({
                start_date:response.start_date,
                end_date:response.end_date,
            });
            employees.summaryDetail  = response.result;
             response.result.map((item) => {
                // employees.summaryDetailById[item.integration_id] = item;
                if(item.integration_id === 1){
                    this.setState({
                        shift_time:item.paid_time,
                        shift_count:item.total_count
                    });
                } else if(item.integration_id === 2){
                    this.setState({
                        time_paid_time:item.paid_time,
                        time_break_time:item.break_time
                    });
                } else if(item.integration_id === 3){
                    this.setState({
                        absence_amount:item.amount,
                        absence_count:item.total_count
                    });
                }else if(item.integration_id === 5){
                    this.setState({
                        workschedule_hour:item.hour
                    });
                }else if(item.integration_id === 6){
                    this.setState({
                        project_hour:item.project_hour,
                        project_count:item.total_count
                    });
                }else if(item.integration_id === 10){
                    this.setState({
                        terminal_count:item.total_count
                    });
                }

                return 0;
             });


          }else{
            Alert.error({title: response.message});
          }
          this.getUserList();
          if(resolve) {
            resolve();
          }
        })
    }
    
    selectDropdown = (key,value) => {
        if(key === 'integration_setting_option'){
            this.setState({'integration_setting_option':value});
            if(value === 'flex_schema'){
                this.getSettingFlexSchema();
            }else if(value === 'time_registration'){
                this.getSettingTimeRegistrationa();
            }else if(value === 'shift_schedule'){
                this.getSettingShiftSchedule();
            }else if(value === 'project'){
                this.getSettingProject();
            }else if(value === 'absence'){
                this.getSettingAbsence();
            }else{

            }
        }else if(key === 'timeregistration_date_filter'){
            this.setState({'timeregistration_date_filter':value});
        }else if(key === 'timeregistration_break_payment'){
            this.setState({'timeregistration_break_payment':value});
        }else if(key === 'timeregistration_break_after'){
            this.setState({'timeregistration_break_after':value});
        }else if(key === 'timeregistration_meeting_minute'){
            this.setState({'timeregistration_meeting_minute':value});
        }else if(key === 'timeregistration_leaving_minute'){
            this.setState({'timeregistration_leaving_minute':value});
        }else if(key === 'timeregistration_auto_logout_time'){
            this.setState({'timeregistration_auto_logout_time':value});
        }else if(key === 'timeregistration_start_of_payment'){
            this.setState({'timeregistration_start_of_payment':value});
        }else{

        }
    };  

    getSettingFlexSchema(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        post(Constent.GETFLEXSCHEMASETTING,formData).then(response=>{
            if(response.status===1){
                let flexoption = response.data;
                this.setState({
                    flex_addedit_record:(flexoption.flex_addedit_record === 1) ? true : false,
                    flex_addedit_schema:(flexoption.flex_addedit_schema === 1) ? true : false,
                    flex_see_schema:(flexoption.flex_see_schema === 1) ? true : false,
                    flex_checkin_with_flex:(flexoption.checkin_with_flex === 1) ? true : false,
                    flex_is_user_menu:(flexoption.is_user_menu === 1) ? true : false,
                });
            }
        })
    }

    getSettingShiftSchedule(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        post(Constent.GETFSHIFTSCHEDULESETTING,formData).then(response=>{
            if(response.status===1){
                let shift_setting = response.data.shift_setting;
                let guest_integration = response.data.guest_integration;
                if(shift_setting){
                    this.setState({
                        shift_sc_hidden_days : shift_setting.hidden_days,
                        
                        shift_sc_display_shift_with_user_module:(shift_setting.checkinout_button === 1) ? true : false,
                        shift_sc_checkinout_with_shift: (shift_setting.checkinout_button === 1) ? true : false,
                        shift_sc_share_shift_schema_publiclly: (shift_setting.is_share === 1) ? true : false,
                        
                        shift_sc_show_hide_empty_rows_on_week_and_day_overvie: (shift_setting.checkinout_button === 1) ? true : false,
                        shift_sc__show_hide_empty_rows_on_webapp: (shift_setting.checkinout_button === 1) ? true : false,
                        shift_sc_employee_pays_breaks: (shift_setting.is_company_paying_break === 1) ? true : false,


                        shift_from_time: shift_setting.start_time,
                        shift_to_time : shift_setting.end_time
                    });    
                }

                if(guest_integration){
                    this.setState({
                        shift_sc_display_shift_with_guest_module: (guest_integration.display_page === 1) ? true : false,
                        integration_tr_text_guest_can_edit_record: (guest_integration.read_write === 1) ? true : false,
                    });
                }
                
              
                this.setState({
                    shift_assignment_list : response.data.assignments,
                    shift_common_shift_list:response.data.commonShift
                });
                
                
            }
        })
    }

    addSettingShiftSchema(){
        var formData =new FormData(); 
        formData.append("department_id",localStorage.getItem("department_id"));
        formData.append("user_id",localStorage.getItem("userid"));
        formData.append("checkinout_button",((this.state.shift_sc_checkinout_with_shift === true) ? '1' : '0'));
        formData.append("webapp_visible_empty_row",((this.state.shift_sc__show_hide_empty_rows_on_webapp === true) ? '1' : '0'));
        formData.append("visible_empty_row",((this.state.shift_sc_show_hide_empty_rows_on_week_and_day_overvie === true) ? '1' : '0'));
        formData.append("is_company_paying_break",((this.state.shift_sc_employee_pays_breaks === true) ? '1' : '0'));
        formData.append("shareschema",((this.state.shift_sc_share_shift_schema_publiclly === true) ? '1' : '0'));
        formData.append("hidden_days",this.state.shift_sc_hidden_days);
        formData.append("start_time",this.state.shift_from_time );
        formData.append("end_time",this.state.shift_to_time);
        formData.append("display_page",((this.state.shift_sc_display_shift_with_user_module === true) ? '1' : '0'));
        formData.append("guest_display_page",((this.state.shift_sc_display_shift_with_guest_module === true) ? '1' : '0'));
        formData.append("guest_read_write",((this.state.integration_tr_text_guest_can_edit_record === true) ? '1' : '0'));
        post(Constent.UPDATESHIFTSCHEMASETTING,formData).then(response=>{
            if(response.status===1){
                Alert.success({title: response.message}) 
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    addSettingFlexSchema(){
        var formData =new FormData(); 
        formData.append("department_id",localStorage.getItem("department_id"));
        formData.append("added_by",localStorage.getItem("userid"));
        formData.append("is_user_menu",((this.state.flex_is_user_menu === true) ? '1' : '0'));
        formData.append("checkin_with_flex",((this.state.flex_checkin_with_flex === true) ? '1' : '0'));
        formData.append("flex_addedit_record",((this.state.flex_addedit_record === true) ? '1' : '0'));
        formData.append("flex_addedit_schema",((this.state.flex_addedit_schema === true) ? '1' : '0'));
        formData.append("flex_see_schema",((this.state.flex_see_schema === true) ? '1' : '0'));
        post(Constent.UPDATEFLEXSCHEMASETTING,formData).then(response=>{
            if(response.status===1){
                Alert.success({title: response.message}) 
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    getSettingTimeRegistrationa(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        post(Constent.GETTIMESTAMPSETTING,formData).then(response=>{
            if(response.status===1){
                let timesoption = response.data;
                this.setState({
                timeregistration_start_of_payment:timesoption.start_of_payment,
                timeregistration_break_payment:timesoption.payment_type,
                timeregistration_date_filter:timesoption.date_filter,
                timeregistration_check_in_out_note:(timesoption.check_in_out_note === 1) ? true : false,
                timeregistration_emp_edit:(timesoption.emp_edit === 1) ? true : false,
                timeregistration_checkin_with_time:(timesoption.checkin_with_time === 1) ? true : false,
                timeregistration_display_page:(timesoption.display_page === 1) ? true : false,
                
                timeregistration_break_after:timesoption.break_after,
                timeregistration_break_time:timesoption.break_time,
                timeregistration_meeting_minute:timesoption.meeting_minute,
                timeregistration_leaving_minute:timesoption.leaving_minute,
                timeregistration_auto_logout_time:timesoption.auto_logout_time,
             });
          }
      })
  }

    addSettingTimeregisteration(){
        var formData =new FormData();
        formData.append("department_id",localStorage.getItem("department_id"));
        formData.append("start_of_payment",this.state.timeregistration_start_of_payment);
        formData.append("date_filter",this.state.timeregistration_date_filter);
        formData.append("check_in_out_note",((this.state.timeregistration_check_in_out_note === true) ? '1' : '0'));
        formData.append("emp_edit",((this.state.timeregistration_emp_edit === true) ? '1' : '0'));
        formData.append("checkin_with_time",((this.state.timeregistration_checkin_with_time === true) ? '1' : '0'));
        formData.append("display_page",((this.state.timeregistration_display_page === true) ? '1' : '0'));
        formData.append("break_after",this.state.timeregistration_break_after);
        formData.append("break_time", this.state.timeregistration_break_time);
        formData.append("payment_type", this.state.timeregistration_break_payment);
        formData.append("meeting_minute",this.state.timeregistration_meeting_minute);
        formData.append("leaving_minute",this.state.timeregistration_leaving_minute);
        formData.append("auto_logout_time",this.state.timeregistration_auto_logout_time);
        post(Constent.UPDATETIMESTAMPSETTING,formData).then(response=>{
            if(response.status===1){
                Alert.success({title: response.message}) 
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    getSettingProject(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        post(Constent.GETPROJECTSETTING,formData).then(response=>{
            if(response.status===1){
                let option = response.data;
                this.setState({
                    project_display_page:(option.display_page === 1) ? true : false,
                    project_choose_project_check_in:(option.choose_project_check_in === 1) ? true : false,
                });
            }
        })
    }

    addSettingProject(){
        var formData =new FormData();
        formData.append("user_id",localStorage.getItem("userid"));
        formData.append("department_id",localStorage.getItem("department_id"));
        formData.append("display_page",((this.state.project_display_page === true) ? '1' : '0'));
        formData.append("choose_project_check_in",((this.state.project_choose_project_check_in === true) ? '1' : '0'));
        post(Constent.UPDATEPROJECTSETTING,formData).then(response=>{
            if(response.status===1){
                Alert.success({title: response.message}) 
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    getNotificationCount(integration_id) {
        if(integration_id == 'attend_device' || integration_id == 'guest_attend_device')
        {
            integration_id = 10;
        }
        let count = 0;

        employees.summaryDetail.forEach(function(item) {
            if(item.integration_id == integration_id) {
                count = item.total_notifications;
            }
        });

        return count;
    }

    getSettingAbsence(){
        var formData=new FormData();
        formData.append("department_id",localStorage.getItem('department_id'));
        post(Constent.GETABSENCESETTING,formData).then(response=>{
            if(response.status===1){
                let option = response.data;
                this.setState({
                    absence_display_page:(option.display_page === 1) ? true : false,
                });
            }
        })
    }

    addSettingAbsence(){
        var formData =new FormData();
        formData.append("user_id",localStorage.getItem("userid"));
        formData.append("department_id",localStorage.getItem("department_id"));
        formData.append("display_page",((this.state.absence_display_page === true) ? '1' : '0'));
        post(Constent.UPDATEABSENCESETTING,formData).then(response=>{
            if(response.status===1){
                Alert.success({title: response.message}) 
            }else{
                Alert.error({title: response.message});
            }
        })
    }

    changeCheckIn = (checkInStatus) => {
        this.setState({checkInStatus: checkInStatus});
    }

    render() {
        const { t } = this.props;
        
        var tmp = [];
        for (var i = 1; i < 29; i++) {
            tmp.push(i);
        }
        var dateofmonth = tmp.map(function (i) {
            return (
              <option value={i} key={i}>{i}</option>
            );
        });

        return (
            <>
                {/* Navigation Bar Imported from Layouts */}
                <Navbar />

                {/* Auto Notification Imported from Layout 
                <AutoNotification /> */}

                {/* Header Starts */}
                <div className="header-area bg-theme" style={{'borderRadius': 0,'background': '#107ce9'}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-sm-3 col-3">
                                <div className="menu-bar">
                                        <Link className="header-user" to={'#'}>
                                            <img src={ this.state.profile_image } alt="img" />
                                        </Link>
                                </div>
                            </div>
                            <div className="col-sm-6 col-6 text-center">
                                <Link to={'/'} className="logo" onClick={()=>{this.getMenuSummery()}}>
                                    <img src={process.env.PUBLIC_URL + '/assets/img/logo.png'} alt="logo" />
                                </Link>
                            </div>
                            <div className="col-sm-3 col-3 text-right">
                                <HeaderRight />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Header Ends */}
                <div className="mg-top-50 bg-theme" style={{'borderRadius': '0 0 10px 10px'}}>
                    <div className="container">
                        <div className="name-area-bg-home">
                            <div className="name-title">
                                <h4 className="title text-overflow">{t('lang.home_sc_hello')} {this.state.user_name}</h4>
                                <h6>{this.state.company_name} <br /> 
                                {(localStorage.getItem('user_type') !== 'user') ? <>
                                <span className="department-name" data-toggle="modal" data-target="#department-modal" style={{marginLeft: 44}}>{ this.state.department_name} <i className="las la-edit"></i></span>
                                <i className="las la-cog setting-icon alignright" data-toggle="modal" data-target="#setting-modal" onClick={()=>{this.getSettingTimeRegistrationa()}}></i></>
                                : <span>{ this.state.department_name}</span>
                                } 

                                </h6>
                            </div>
                        </div>
                    </div>
                </div>

            <PullToRefresh
                pullDownContent={<PullDownContent label='' />}
                releaseContent={false}
                refreshContent={<RefreshContent />}
                pullDownThreshold={2}
                onRefresh={this.handleRefresh}
                triggerHeight={500}
                startInvisible= {true}
            >    
                {/* goal area Start  */}
                <div className="home-page goal-area pd-top-15">
                    <div className="container padding-0"> 
                        <ul className="transaction-inner">
                            
                        { employees.menu.map(({ integration_id, total_notifications, integration_name,integration_icon,page_url}, index) => (
                            <li className="ba-single-transaction style-two" key={integration_id}>
                                {this.getNotificationCount(integration_id) != 0 &&
                                    <div className="mnotification">
                                        {this.getNotificationCount(integration_id) }
                                    </div>
                                }
                                <div className="thumb">
                                    <Link to={page_url}>
                                        <img src={process.env.PUBLIC_URL + '/assets/integration/'+integration_icon} alt="img" />
                                    </Link>
                                </div>
                                <div className="details">
                                    <Link to={page_url}>
                                        <h5>{integration_name}</h5>
                       
                                        { (integration_id === 1) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_shift_hours')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.shift_time}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_total_shift')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.shift_count}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                        { (integration_id === 2) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_paid_time')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.time_paid_time}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_break_time')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.time_break_time}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                        { (integration_id === 3) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_absence_amount')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.absence_amount}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_total_absence')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.absence_count}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                        { (integration_id === 5) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_flex_time')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.workschedule_hour}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                        { (integration_id === 6) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_project_time')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.project_hour}</span>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_total_project')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.project_count}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}

                                        { ( (integration_id === 'attend_device') || (integration_id === 'guest_attend_device') ) ?
                                            <>
                                            <div className="row">
                                                <div className="col-8">
                                                    <span>{t('lang.home_sc_total_terminal')}:</span>
                                                </div>
                                                <div className="col-4">
                                                    <span className="value">{this.state.terminal_count}</span>
                                                </div>
                                            </div>
                                        </>
                                        : ''}
                                    </Link>
                                </div>
                            </li>
                        )) }
                        </ul>

                      

                    </div>
                </div>
                {/* goal area End */}
            </PullToRefresh>
                
                {(this.state.is_user_list_carousel === true) ? 
                    <UserSlider user_list_carousel={this.state.user_list_carousel} />
                : ''}

                {/* Modal One start  */}
                    <div id="department-modal" className="home-page modal modal-top fade">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{t('lang.home_sc_department')}</h5>
                                    <div className="modal-close" data-dismiss="modal">
                                        <i className="la la-times" />
                                    </div>
                                </div>
                                <div className="modal-body">
                                    <div>
                                        <ul className="transaction-details-inner">
                                            { this.state.department_list.map(({ department_id, department_name}) => (
                                            <li key={department_id} className={(this.state.department_id === department_id) ? 'active' : ''}>
                                                <Link to={'#'} onClick={e => { 
                                                    Alert.confirm({
                                                        position:'toast-top-full-width',
                                                        message: t('lang.message_are_you_sure'),
                                                        btn_yes: t('lang.btn_text_yes_do_it'),
                                                        action: () =>{   
                                                            this.handleChangeDepartment(department_id)
                                                        }
                                                    })
                                                    
                                                    }}>
                                                    <span className="float-left">{department_name}</span>
                                                    <span className="float-right"><i className="la la-angle-right" /></span>
                                                </Link>
                                            </li>
                                            ))}
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                      </div>  

                    {/* Modal One start  */}
                    <div id="setting-modal" className="home-page modal modal-top fade">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                                <div className="modal-header">
                                    <h5 className="modal-title">{t('lang.common_text_settings')}</h5>
                                    <div className="modal-close" data-dismiss="modal">
                                        <i className="la la-times" />
                                    </div>
                                </div>
                                    <select value={this.state.integration_setting_option} 
                                    className="form-control mb-2" style={{background: 'rgb(230, 230, 230)'}}
                                     onChange={e => { this.selectDropdown('integration_setting_option',e.target.value)}}>
                                        <option value='general'>{t('lang.integration_text_general')}</option>
                                        <option value='time_registration'>{t('lang.menu_name_time_registration')}</option>
                                        <option value='shift_schedule'>{t('lang.menu_name_shift_schedule')}</option>
                                        <option value='flex_schema'>{t('lang.menu_name_flex_schema')}</option>
                                        <option value='project'>{t('lang.menu_name_project')}</option>
                                        <option value='absence'>{t('lang.menu_name_absence')}</option>
                                        </select>
                                <div className="modal-body">

                                    {this.state.integration_setting_option === 'general' ?   
                                        <>
                                            <span className="label">{t('lang.integration_text_select_start_of_payment')}</span>
                                            <div className="input-group mb-4">
                                                <select value={this.state.timeregistration_start_of_payment} 
                                                className="form-control" style={{maxWidth: '20%'}}
                                                 onChange={e => { this.selectDropdown('timeregistration_start_of_payment',e.target.value)}}>
                                                    <option>{t('lang.common_text_select')}</option>
                                                    {dateofmonth}
                                                </select>

                                                <select value={this.state.timeregistration_date_filter} 
                                                className="form-control"
                                                 onChange={e => { this.selectDropdown('timeregistration_date_filter',e.target.value)}}>
                                                    <option value='weekly'>{t('lang.integration_text_every_week')}</option>
                                                    <option value='2_weekly'>{t('lang.integration_text_every_2_week')}</option>
                                                    <option value='monthly'>{t('lang.integration_text_every_month')}</option>
                                                    <option value='3_monthly'>{t('lang.integration_text_every_3_month')}</option>
                                                </select>
                                            </div>

                                            <span className="label">{t('lang.integration_text_break_payment')}</span>
                                            <div className="input-group mb-1">
                                                <select value={this.state.timeregistration_break_payment} 
                                                className="form-control"
                                                 onChange={e => { this.selectDropdown('timeregistration_break_payment',e.target.value)}}>
                                                    <option >{t('lang.common_text_select')}</option>
                                                    <option value='1'>{t('lang.absence_sc_company')}</option>
                                                    <option value='0'>{t('lang.absence_sc_staff')}</option>
                                                  </select>
                                            </div><br></br><br></br><br></br><br></br>
                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingTimeregisteration()}}>{t('lang.modal_btn_save')}</button>
                                        </>
                                    : '' }
                                    
                                    {this.state.integration_setting_option === 'time_registration' ?   
                                        <>
                                            {/* Start timeregistration */}
                                            <ul className="nav nav-tabs" id="example-one" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="base-tab-1" data-toggle="tab" href="#tab-1" role="tab" aria-controls="tab-1" aria-selected="true">{t('lang.navigation_sc_access')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-2" data-toggle="tab" href="#tab-2" role="tab" aria-controls="tab-2" aria-selected="false">{t('lang.employee_sc_guest')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-3" data-toggle="tab" href="#tab-3" role="tab" aria-controls="tab-3" aria-selected="false">{t('lang.common_text_break')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="base-tab-4" data-toggle="tab" href="#tab-4" role="tab" aria-controls="tab-4" aria-selected="false">{t('lang.common_text_rules')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-4">
                                            <div className="tab-pane fade show active" id="tab-1" role="tabpanel" aria-labelledby="base-tab-1">
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            className="toggle-switch-checkbox"
                                                            value="1"
                                                            id="timeregistration_check_in_out_note"
                                                            checked={this.state.timeregistration_check_in_out_note}
                                                            onChange={e => { this.setState({timeregistration_check_in_out_note:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_check_in_out_note"> {t('lang.integration_tr_text_display_note_with_check_in_out')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="timeregistration_emp_edit"
                                                            value="1"
                                                            checked={this.state.timeregistration_emp_edit}
                                                            onChange={e => { this.setState({timeregistration_emp_edit:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_emp_edit"> {t('lang.integration_tr_text_emp_can_edit_record')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="timeregistration_checkin_with_time"
                                                            value="1"
                                                            checked={this.state.timeregistration_checkin_with_time}
                                                            onChange={e => { this.setState({timeregistration_checkin_with_time:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_checkin_with_time"> {t('lang.integration_tr_text_checkinout_with_time')}</label>
                                                    </span>
                                                </div>

                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="timeregistration_display_page"
                                                            value="1"
                                                            checked={this.state.timeregistration_display_page}
                                                            onChange={e => { this.setState({timeregistration_display_page:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_display_page"> {t('lang.integration_tr_text_display_timeregistraion_with_user_module')}</label>
                                                    </span>
                                                </div>

                                                
                                            </div>
                                            <div className="tab-pane fade" id="tab-2" role="tabpanel" aria-labelledby="base-tab-2">
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="timeregistration_display_page_guest"
                                                            value="1"
                                                            checked={this.state.timeregistration_display_page_guest}
                                                            onChange={e => { this.setState({timeregistration_display_page_guest:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_display_page_guest"> {t('lang.integration_tr_text_display_timeregistraion_with_guest_module')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="timeregistration_guest_edit"
                                                            value="1"
                                                            checked={this.state.timeregistration_guest_edit}
                                                            onChange={e => { this.setState({timeregistration_guest_edit:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="timeregistration_guest_edit"> {t('lang.integration_tr_text_guest_can_edit_record')}</label>
                                                    </span>
                                                </div><br></br><br></br><br></br><br></br>
                                            </div>
                                            <div className="tab-pane fade" id="tab-3" role="tabpanel" aria-labelledby="base-tab-3">
                                                <span className="label">{t('lang.integration_break_text_work_hour')}</span>
                                                <div className="input-group mb-4">
                                                    <select value={this.state.timeregistration_break_after} 
                                                    className="form-control"
                                                     onChange={e => { this.selectDropdown('timeregistration_break_after',e.target.value)}}>
                                                        <option>{t('lang.common_text_select')}</option>
                                                        <option value="01:00">01:00 {t('lang.common_text_hour')}</option>
                                                        <option value="02:00">02:00 {t('lang.common_text_hour')}</option>
                                                        <option value="03:00">03:00 {t('lang.common_text_hour')}</option>
                                                        <option value="04:00">04:00 {t('lang.common_text_hour')}</option>
                                                        <option value="05:00">05:00 {t('lang.common_text_hour')}</option>
                                                        <option value="05:45">05:45 {t('lang.common_text_hour')}</option>
                                                        <option value="06:00">06:00 {t('lang.common_text_hour')}</option>
                                                        <option value="07:00">07:00 {t('lang.common_text_hour')}</option>
                                                      </select>
                                                </div>

                                                <span className="label">{t('lang.integration_break_text_get_break_in_minute')}</span>
                                                <div className="input-group mb-4">
                                                    <input type="number" placeholder="01" className="form-control"
                                                        value={this.state.timeregistration_break_time}
                                                        onChange={e => { this.setState({timeregistration_break_time:e.target.value}) }} 
                                                     />
                                                </div>
                                                <span className="label">{t('lang.integration_text_break_payment')}</span>
                                                <div className="input-group mb-4">
                                                    <select value={this.state.timeregistration_break_payment} 
                                                    className="form-control"
                                                     onChange={e => { this.selectDropdown('timeregistration_break_payment',e.target.value)}}>
                                                        <option>{t('lang.common_text_select')}</option>
                                                        <option value='1'>{t('lang.absence_sc_company')}</option>
                                                        <option value='0'>{t('lang.absence_sc_staff')}</option>
                                                      </select>
                                                </div>
                                            </div>
                                            <div className="tab-pane fade" id="tab-4" role="tabpanel" aria-labelledby="base-tab-4">
                                                    <span className="label">{t('lang.integration_rule_text_meeting_minute')}</span>
                                                    <div className="input-group mb-4">
                                                        <select value={this.state.timeregistration_meeting_minute} 
                                                        className="form-control"
                                                         onChange={e => { this.selectDropdown('timeregistration_meeting_minute',e.target.value)}}>
                                                            <option>{t('lang.common_text_select')}</option>
                                                            <option value="5">05</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                            <option value="30">30</option>
                                                          </select>
                                                    </div>

                                                    <span className="label">{t('lang.integration_rule_text_leaving_minute')}</span>
                                                    <div className="input-group mb-4">
                                                        <select value={this.state.timeregistration_leaving_minute} 
                                                        className="form-control"
                                                         onChange={e => { this.selectDropdown('timeregistration_leaving_minute',e.target.value)}}>
                                                            <option>{t('lang.common_text_select')}</option>
                                                            <option value="5">05</option>
                                                            <option value="10">10</option>
                                                            <option value="15">15</option>
                                                            <option value="30">30</option>
                                                          </select>
                                                    </div>

                                                    <span className="label">{t('lang.integration_rule_text_auto_logout_time')}</span>
                                                    <div className="input-group mb-4">
                                                        <select value={this.state.timeregistration_auto_logout_time} 
                                                        className="form-control"
                                                         onChange={e => { this.selectDropdown('timeregistration_auto_logout_time',e.target.value)}}>
                                                            <option value="">{t('lang.terminal_menu_sc_select_option')}</option>
                                                            <option value="01:00">01:00</option>
                                                            <option value="02:00">02:00</option>
                                                            <option value="03:00">03:00</option>
                                                            <option value="04:00">04:00</option>
                                                            <option value="05:00">05:00</option>
                                                            <option value="06:00">06:00</option>
                                                            <option value="07:00">07:00</option>
                                                            <option value="08:00">08:00</option>
                                                            <option value="09:00">09:00</option>
                                                            <option value="10:00">10:00</option>
                                                            <option value="11:00">11:00</option>
                                                            <option value="12:00">12:00</option>
                                                            <option value="13:00">13:00</option>
                                                            <option value="14:00">14:00</option>
                                                            <option value="15:00">15:00</option>
                                                            <option value="16:00">16:00</option>
                                                            <option value="17:00">17:00</option>
                                                            <option value="18:00">18:00</option>
                                                            <option value="19:00">19:00</option>
                                                            <option value="20:00">20:00</option>
                                                            <option value="21:00">21:00</option>
                                                            <option value="22:00">22:00</option>
                                                            <option value="23:00">23:00</option>
                                                          </select>
                                                    </div>
                                            </div>
                                        </div>
                                            
                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingTimeregisteration()}}>{t('lang.modal_btn_save')}</button>
                                            {/* End timeregistration */}
                                        </>
                                    : '' }

                                    {this.state.integration_setting_option === 'flex_schema' ?   
                                        <>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    value="1"
                                                    id="display_flex_schema_with_user_module"
                                                    checked={this.state.flex_is_user_menu}
                                                    onChange={e => { this.setState({flex_is_user_menu:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="display_flex_schema_with_user_module"> {t('lang.integration_flex_text_display_flex_schema_with_user_module')}</label>
                                            </span>
                                            </div>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    id="employee_can_see_week_schema"
                                                    value="1"
                                                    checked={this.state.flex_see_schema}
                                                    onChange={e => { this.setState({flex_see_schema:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="employee_can_see_week_schema"> {t('lang.integration_flex_text_employee_can_see_week_schema')}</label>
                                            </span>
                                            </div>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    id="employee_may_edit_insert_week_schema"
                                                    value="1"
                                                    checked={this.state.flex_addedit_schema}
                                                    onChange={e => { this.setState({flex_addedit_schema:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="employee_may_edit_insert_week_schema"> {t('lang.integration_flex_text_employee_may_edit_insert_week_schema')}</label>
                                            </span>
                                            </div>

                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    id="employee_can_edit_record"
                                                    value="1"
                                                    checked={this.state.flex_addedit_record}
                                                    onChange={e => { this.setState({flex_addedit_record:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="employee_can_edit_record"> {t('lang.integration_flex_text_employee_can_edit_record')}</label>
                                            </span>
                                            </div>

                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    id="checkinout_with_flex_schema"
                                                    value="1"
                                                    checked={this.state.flex_checkin_with_flex}
                                                    onChange={e => { this.setState({flex_checkin_with_flex:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="checkinout_with_flex_schema"> {t('lang.integration_flex_text_checkinout_with_flex_schema')}</label>
                                            </span>
                                            </div>

                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingFlexSchema()}}>{t('lang.modal_btn_save')}</button>
                                            
                                        </>
                                    : '' }    
                                    
                                    {this.state.integration_setting_option === 'project' ?   
                                        <><br></br>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    value="1"
                                                    id="project_display_page"
                                                    checked={this.state.project_display_page}
                                                    onChange={e => { this.setState({project_display_page:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="project_display_page"> {t('lang.project_sc__display_project_with_user_module.')}</label>
                                            </span>
                                            </div>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    id="project_choose_project_check_in"
                                                    value="1"
                                                    checked={this.state.project_choose_project_check_in}
                                                    onChange={e => { this.setState({project_choose_project_check_in:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="project_choose_project_check_in"> {t('lang.project_sc_choose_project_during_check_in')}</label>
                                            </span>
                                            </div>
                                            <br></br><br></br><br></br><br></br>
                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingProject()}}>{t('lang.modal_btn_save')}</button>
                                            
                                        </>
                                    : '' } 

                                    {this.state.integration_setting_option === 'absence' ?   
                                        <><br></br>
                                            <div className="input-group mb-4">
                                            <span className="single-switch">
                                                <label className="switch">
                                                    <input type="checkbox" 
                                                    value="1"
                                                    id="absence_display_page"
                                                    checked={this.state.absence_display_page}
                                                    onChange={e => { this.setState({absence_display_page:e.target.checked}) }} 
                                                    />
                                                    <span className="slider round" />
                                                </label>
                                                <label className="label" htmlFor="absence_display_page"> {t('lang.absence_sc_display_absence_with_user_module')}</label>
                                            </span>
                                            </div>
                                            
                                            <br></br><br></br><br></br><br></br><br></br>
                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingAbsence()}}>{t('lang.modal_btn_save')}</button>
                                            
                                        </>
                                    : '' } 

                                    {this.state.integration_setting_option === 'shift_schedule' ?   
                                        <>
                                            {/* Start Shift Schema */}
                                            <ul className="nav nav-tabs" id="example-shift" role="tablist">
                                            <li className="nav-item">
                                                <a className="nav-link active" id="shift-tab-1" data-toggle="tab" href="#shifttab-1" role="tab" aria-controls="tab-1" aria-selected="true">{t('lang.integration_shift_user_access')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="shift-tab-2" data-toggle="tab" href="#shifttab-2" role="tab" aria-controls="tab-2" aria-selected="false">{t('lang.integration_shift_text_overview')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="shift-tab-3" data-toggle="tab" href="#shifttab-3" role="tab" aria-controls="tab-3" aria-selected="false">{t('lang.integration_shift_text_assignment')}</a>
                                            </li>
                                            <li className="nav-item">
                                                <a className="nav-link" id="shift-tab-4" data-toggle="tab" href="#shifttab-4" role="tab" aria-controls="tab-4" aria-selected="false">{t('lang.integration_shift_common_shift')}</a>
                                            </li>
                                        </ul>
                                        <div className="tab-content pt-3">
                                            <div className="tab-pane fade show active" id="shifttab-1" role="tabpanel" aria-labelledby="shift-tab-1">
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            className="toggle-switch-checkbox"
                                                            value="1"
                                                            id="shift_sc_display_shift_with_user_module"
                                                            checked={this.state.shift_sc_display_shift_with_user_module}
                                                            onChange={e => { this.setState({shift_sc_display_shift_with_user_module:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_display_shift_with_user_module"> {t('lang.shift_sc_display_shift_with_user_module')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc_checkinout_with_shift"
                                                            value="1"
                                                            checked={this.state.shift_sc_checkinout_with_shift}
                                                            onChange={e => { this.setState({shift_sc_checkinout_with_shift:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_checkinout_with_shift">{t('lang.shift_sc_checkinout_with_shift')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc_share_shift_schema_publiclly"
                                                            value="1"
                                                            checked={this.state.shift_sc_share_shift_schema_publiclly}
                                                            onChange={e => { this.setState({shift_sc_share_shift_schema_publiclly:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_share_shift_schema_publiclly"> {t('lang.shift_sc_share_shift_schema_publiclly')}</label>
                                                    </span>
                                                </div>
                                                <hr />
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc_display_shift_with_guest_module"
                                                            value="1"
                                                            checked={this.state.shift_sc_display_shift_with_guest_module}
                                                            onChange={e => { this.setState({shift_sc_display_shift_with_guest_module:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_display_shift_with_guest_module"> {t('lang.shift_sc_display_shift_with_guest_module')}</label>
                                                    </span>
                                                </div>

                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="integration_tr_text_guest_can_edit_record"
                                                            value="1"
                                                            checked={this.state.integration_tr_text_guest_can_edit_record}
                                                            onChange={e => { this.setState({integration_tr_text_guest_can_edit_record:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="integration_tr_text_guest_can_edit_record"> {t('lang.integration_tr_text_guest_can_edit_record')}</label>
                                                    </span>
                                                </div>

                                                
                                            </div>
                                            <div className="tab-pane fade" id="shifttab-2" role="tabpanel" aria-labelledby="shift-tab-2">
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc_show_hide_empty_rows_on_week_and_day_overvie"
                                                            value="1"
                                                            checked={this.state.shift_sc_show_hide_empty_rows_on_week_and_day_overvie}
                                                            onChange={e => { this.setState({shift_sc_show_hide_empty_rows_on_week_and_day_overvie:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_show_hide_empty_rows_on_week_and_day_overvie">{t('lang.shift_sc_show_hide_empty_rows_on_week_and_day_overvie')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc__show_hide_empty_rows_on_webapp"
                                                            value="1"
                                                            checked={this.state.shift_sc__show_hide_empty_rows_on_webapp}
                                                            onChange={e => { this.setState({shift_sc__show_hide_empty_rows_on_webapp:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc__show_hide_empty_rows_on_webapp"> {t('lang.shift_sc__show_hide_empty_rows_on_webapp')}</label>
                                                    </span>
                                                </div>
                                                <div className="input-group mb-4">
                                                    <span className="single-switch">
                                                        <label className="switch">
                                                            <input type="checkbox" 
                                                            id="shift_sc_employee_pays_breaks"
                                                            value="1"
                                                            checked={this.state.shift_sc_employee_pays_breaks}
                                                            onChange={e => { this.setState({shift_sc_employee_pays_breaks:e.target.checked}) }} 
                                                            />
                                                            <span className="slider round" />
                                                        </label>
                                                        <label className="label" htmlFor="shift_sc_employee_pays_breaks"> {t('lang.shift_sc_employee_pays_breaks')}</label>
                                                    </span>
                                                </div>
                                                <hr/>    
                                                <div>
                                                    <div className="mb-3">{t('lang.shift_sc_choose_the_working_day_of_your_company')}</div>
                                                        <div className="row">
                                                            <div className="col-4">
                                                                <input type="checkbox" 
                                                                id="day_monday"
                                                                value="1"
                                                                checked={this.state.day_monday}
                                                                onChange={e => { this.setState({day_monday:e.target.checked}) }} 
                                                                /><label className="label" htmlFor="day_monday"> {t('lang.day_monday')}</label>
                                                            </div>
                                                            <div className="col-4">
                                                                <input type="checkbox" 
                                                                id="day_tuesday"
                                                                value="1"
                                                                checked={this.state.day_tuesday}
                                                                onChange={e => { this.setState({day_tuesday:e.target.checked}) }} 
                                                                /><label className="label" htmlFor="day_tuesday"> {t('lang.day_tuesday')}</label>
                                                            </div>
                                                            <div className="col-4">
                                                                <input type="checkbox" 
                                                                id="day_wednesday"
                                                                value="1"
                                                                checked={this.state.day_wednesday}
                                                                onChange={e => { this.setState({day_wednesday:e.target.checked}) }} 
                                                                /><label className="label" htmlFor="day_wednesday"> {  t('lang.day_wednesday').substring(0,3) }</label>
                                                            </div>
                                                            <div className="col-4">
                                                                <input type="checkbox" 
                                                                id="day_thursday"
                                                                value="1"
                                                                checked={this.state.day_thursday}
                                                                onChange={e => { this.setState({day_wednesday:e.target.checked}) }} 
                                                                /><label className="label" htmlFor="day_thursday"> {t('lang.day_thursday')}</label>
                                                            </div>
                                                            <div className="col-4">
                                                                <input type="checkbox" 
                                                                id="day_friday"
                                                                value="1"
                                                                checked={this.state.day_friday}
                                                                onChange={e => { this.setState({day_friday:e.target.checked}) }} 
                                                                /><label className="label" htmlFor="day_friday"> {t('lang.day_friday')}</label>
                                                            </div>
                                                        <div className="col-4">
                                                        <input type="checkbox" 
                                                        id="day_saturday"
                                                        value="1"
                                                        checked={this.state.day_saturday}
                                                        onChange={e => { this.setState({day_saturday:e.target.checked}) }} 
                                                        /><label className="label" htmlFor="day_saturday"> {t('lang.day_saturday').substring(0,3)}</label>
                                                         </div>
                                                        <div className="col-4">
                                                        <input type="checkbox" 
                                                        id="day_sunday"
                                                        value="1"
                                                        checked={this.state.day_sunday}
                                                        onChange={e => { this.setState({day_sunday:e.target.checked}) }} 
                                                        /><label className="label" htmlFor="day_sunday"> {t('lang.day_sunday')}</label>
                                                    </div></div>
                                                </div>
                                                <hr/>
                                                <div>
                                                    <div className="mb-3">{t('lang.shift_sc_working_open_hours')}</div>
                                                    <div className="row">
                                                        <div className="col-6">
                                                            <span className="label">{t('lang.shift_sc_from_time') }</span>
                                                            <div className="input-group mb-1">
                                                                <input type="time" className="form-control form-control-lg"
                                                                value={this.state.shift_from_time} 
                                                                onChange={e => { this.setState({shift_from_time: e.target.value})}} />
                                                            </div>
                                                        </div>    
                                                        <div className="col-6">
                                                            <span className="label">{t('lang.shift_sc_to_time') }</span>
                                                            <div className="input-group mb-1">
                                                                <input type="time" className="form-control form-control-lg"
                                                                value={this.state.shift_to_time} 
                                                                onChange={e => { this.setState({shift_to_time: e.target.value})}} />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="tab-pane fade" id="shifttab-3" role="tabpanel" aria-labelledby="shift-tab-3">
                                                {this.state.shift_assignment_list.map(({ id, font_color, choose_absence,name}) => (
                                                <div key={id}> <span style={{background:choose_absence, width:50, height:50}}>&nbsp;</span> {name}</div>
                                                ))}
                                            </div>
                                            <div className="tab-pane fade" id="shifttab-4" role="tabpanel" aria-labelledby="shift-tab-4">
                                                {this.state.shift_common_shift_list.map(({ id, from, to}) => (
                                                <div key={id}>{from}-{to}</div>
                                                ))}    
                                            </div>
                                        </div>
                                            
                                            <button type="button" className="btn-c btn-success btn-block mt-5" onClick={()=>{this.addSettingShiftSchema()}}>{t('lang.modal_btn_save')}</button>
                                            {/* End Shift Schema */}
                                        </>
                                    : '' }        
                                        </div>
                               
                            </div>
                        </div>
                      </div>  
                    {/* Modal One end  */}

                {/* Check in popip end  */}
                    <CheckinPopup setCheckInStatus = {this.changeCheckIn}  checkinoutScreen="time" p_userid={localStorage.getItem('userid')}/>
                {/* Checkin popup end  */}
            </>
        );
    }
}

export default withTranslation('common')(Home);